/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import "./ARControllerUI.css";
import { React } from "react";
import create from "zustand";
import { AR_POSITION_SEEK, XR_MODES } from "../constants";
import Event from "../modules/Event";
import Tracker from "../modules/CommonTracker";

const store = (set) => ({
  xrMode: XR_MODES.XR,
  setXRMode: (xrMode) => set({ xrMode }),
  positionSelection: false,
  setPositionSelection: (positionSelection) => set({ positionSelection }),
  enableARSwitch: false,
  setEnableARSwitch: (enableARSwitch) => set({ enableARSwitch }),
});

const useARControllerUIStore = create(store);
export const ARControllerUIState = useARControllerUIStore.getState;

function ARControllerUI({ customStyleClass }) {
  const [
    xrMode,
    setXRMode,
    positionSelection,
    enableARSwitch,
    setEnableARSwitch,
  ] = useARControllerUIStore((s) => [
    s.xrMode,
    s.setXRMode,
    s.positionSelection,
    s.enableARSwitch,
    s.setEnableARSwitch,
  ]);

  const toggleXRMode = () => {
    console.log("XRMODE", xrMode);
    const mode = xrMode === XR_MODES.XR ? XR_MODES.AR : XR_MODES.XR;
    // Tracker.sendToGa(
    //   xrMode.toUpperCase(),
    //   "",
    //   `Switch to ${mode.toUpperCase()}`,
    //   "Toggle View",
    //   false
    // );
    Tracker.sendAnalyticsEvent(
      xrMode.toUpperCase(),
      { action: "onClick Button" },
      { nonInteraction: true },
      {
        mode,
        referrer: "Switch Button - AR/XR",
      }
    );
    setEnableARSwitch(false);
    if (xrMode === XR_MODES.XR) {
      Event.sendSMEvent(XR_MODES.AR);
      setXRMode(XR_MODES.AR);
    } else {
      Event.sendSMEvent(XR_MODES.XR);
      setXRMode(XR_MODES.XR);
    }
  };

  const setPosition = () => {
    console.log("Clicked set position");
    Event.sendSMEvent(AR_POSITION_SEEK.SET_START);
  };

  const renderSwitchButton = () => (
    <div className="switch-button">
      <input
        checked={xrMode === XR_MODES.AR}
        className="switch-button-checkbox"
        type="checkbox"
        onChange={() => {
          if (enableARSwitch) {
            toggleXRMode();
          }
        }}
      />
      <label className="switch-button-label">
        <span className="switch-button-label-span">VIEW IN 3D</span>
      </label>
    </div>
  );

  return (
    <div>
      <div className={`ARControllerContainer ${customStyleClass}`}>
        {positionSelection && (
          <div
            className="screen-container"
            onClick={setPosition}
            style={{ pointerEvents: "all" }}
          >
            <div>{renderSwitchButton()}</div>
          </div>
        )}
        {!positionSelection && renderSwitchButton()}
      </div>
    </div>
  );
}

export default ARControllerUI;
